<page-heading
  [title]="'kanban.lossReason.pageTitle' | translate"
  [description]="'kanban.lossReason.pageDescription' | translate"
/>

<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-xs-12 col-md-9 input-trend-search">
            <input
              type="search"
              #searchBox
              class="form-control"
              [placeholder]="'kanban.lossReason.searchPlaceholder' | translate"
              (keyup)="search(searchBox.value)"
            />
            <span class="mdi mdi-magnify search-icon ml-2"></span>
          </div>

          <div class="col-xs-12 col-lg-3 btn-group trend-button">
            <button class="btn btn-info fw-bold" (click)="add()">{{ 'kanban.lossReason.add' | translate }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- E3 RF-36 (ADR-001): the platform's discard reasons, visibly distinct from the company's rows and locked. -->
<div class="card">
  <div class="card-body">
    <h4 class="header-title">{{ 'kanban.lossReason.platformTitle' | translate }}</h4>
    <p class="text-muted mb-2 font-13">{{ 'kanban.lossReason.platformHint' | translate }}</p>
    <div class="d-flex flex-wrap gap-2">
      @for (key of platformReasons; track key) {
        <span class="badge bg-soft-secondary text-muted font-13 d-inline-flex align-items-center gap-1">
          <i class="mdi mdi-lock-outline"></i>
          {{ DISCARD_REASON_LABEL[key] | translate }}
        </span>
      }
    </div>
  </div>
</div>

@if (loadingContent) {
  <content-loading-list />
}

@if (pager.total === 0) {
  <empty-records-component
    [message]="'kanban.lossReason.emptyMessage' | translate"
    [subMessage]="'kanban.lossReason.emptySubMessage' | translate"
    [icon]="'mdi mdi-alert-circle-outline'"
    [labelButton]="'kanban.lossReason.add' | translate"
    (emitEvent)="add()"
  />
}

@if (!loadingContent && pager.total > 0) {
<div class="card">
  <div class="card-body table-responsive">
    <table class="table table-hover table-centered mb-0">
      <thead>
        <tr>
          <th class="text-primary-emphasis">{{ 'kanban.lossReason.name' | translate }}</th>
          <th class="text-primary-emphasis">{{ 'kanban.lossReason.description' | translate }}</th>
          <th><span class="sr-only"></span></th>
        </tr>
      </thead>
      <tbody>
        @for (item of pager.list; track $index) {
        <tr>
          <td>{{ item.name }}</td>
          <td class="text-truncate">{{ item.description ?? "-" }}</td>
          <td>
            <div class="d-flex justify-content-end">
              <button
                type="button"
                class="btn btn-dropdown-list"
                [matMenuTriggerFor]="menu"
              >
                <i class="mdi mdi-dots-vertical text-primary-emphasis"></i>
              </button>

              <mat-menu #menu="matMenu">
                <button mat-menu-item tabindex="0" (click)="edit(item)">
                  {{ 'kanban.lossReason.edit' | translate }}
                </button>
                @if (isAdmin()) {
                <button mat-menu-item tabindex="0" (click)="delete(item)">
                  {{ 'kanban.lossReason.delete' | translate }}
                </button>
                }
              </mat-menu>
            </div>
          </td>
        </tr>
        }
      </tbody>
    </table>
  </div>
</div>
}
